export default class PublicationStatus {
  constructor($publication) {
    this.$publication = $publication

    this.updateStatus()
  }

  updateStatus() {
    this.$status = this.$publication.find('.js-publication-status')

    if (this.$status.val() === 'draft') {
      this.$publication.find('.form__caption').show()
    } else {
      this.$publication.find('.form__caption').hide()
    }

    if (this.$status.val() === 'scheduled') {
      this.$publication.find('.js-publication-date').show()
      this.$status.closest('.form__group').removeClass('form__group--no-margin')
    } else {
      this.$publication.find('.js-publication-date').hide()
      this.$status.closest('.form__group').addClass('form__group--no-margin')
    }
  }
}
